import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IVatField {
	changeVat: (value: string) => void;
}

const VatField: React.FC<IVatField> = ({ changeVat }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterVat') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			changeVat(onlyDigits);
			return onlyDigits;
		},
		[changeVat],
	);

	return (
		<FormInput
			testId="VatField"
			name="vat"
			label="vatLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(VatField);
